const getCurrentUser = () => {};

export default getCurrentUser;
